import * as React from "react";
import {Component, Fragment} from "react";
import Card from "../../Card/Card";
import KeySolver from "../../../KeySolver";
import Filter from "../../Filter/Filter";
import ColorSelect from "./ColorSelect";
import FetchData from "../../../backend/FetchData";
import Spinner from "../../Process/Spinner";

export default class PatternSelect extends ColorSelect {

	// shouldComponentUpdate(nextProps, nextState, nextContext) {
	// 	return false;
	// }

	render() {

		const {items, categories, value} = this.state;
		const {reference, id, dataId, volant, inputType} = this.props;

		return (
			<Fragment>
				{items && items.length === 0 &&
					<div className="d-flex align-items-center text-center justify-content-center">
						<Fragment>
							<Spinner style="rotate" />
							<span className="ms-3 text-primary">
								Stoffmuster werden geladen ...
							</span>
						</Fragment>
					</div>
				}
				{items &&
					<Fragment>
						{items.length > 0 &&
							<Fragment>
								<Filter placeholder="Suchen ..." items={items} filterel={`pattern_${inputType}`} inputType={inputType} />
								<div className="color-select" data-filterel={`pattern_${inputType}`} >
									<div className="color-select-wrapper">
										{items.map(item =>
											<Fragment key={KeySolver()} >
												<PatternItem item={item} value={value} volant={volant} inputType={inputType} handleClick={(p) => this.handleClick(p)} />
											</Fragment>
										)}
									</div>
								</div>
							</Fragment>
						}
					</Fragment>
				}
				<input ref={reference} id={id} type="hidden" className="form-control form-control-lg" data-id={dataId} value={value} readOnly={true} />
				{/*{items.map((item, i) =>*/}
				{/*	<Fragment key={KeySolver()} >*/}
				{/*		<input type="radio" id={item.fileUrl.label} defaultValue={item.fileUrl.label} defaultChecked={item.fileUrl.label === value ? true : false} />*/}
				{/*	</Fragment>*/}
				{/*)}*/}
			</Fragment>
		);
	}
}

class PatternItem extends Component {

	constructor(props) {
		super(props);
		this.state = {
			fetched: false,
			imageExist: false,
			imageUrl: '',
		}
		// this.imageExist = this.imageExist.bind(this)
		// this.fetchImage = this.fetchImage.bind(this)
		this.handleClick = this.handleClick.bind(this)
	}

	handleClick(val) {
		// console.log(`click: ${val}`);
		this.props.handleClick(val);
	}


	componentDidMount() {
		// const {item} = this.props;
		// this.imageExist(item.filename);
		// this.imageExist(item.fileUrl.signedUrl);
		// this.fetchImage();

		const variovolantPattern = document.querySelectorAll('button[data-variovolant]');
		if(variovolantPattern && variovolantPattern.length > 0){} {

			setInterval(() => {

				const variovolant1 = document.querySelector('input[data-id="check-volant"]');
				const variovolant2 = document.querySelector('input[data-id="check-variovolant_900"]');
				const variovolant3 = document.querySelector('input[data-id="check-variovolant_1500"]');

				if((variovolant1 && variovolant1.checked) || (variovolant2 && variovolant2.checked) || (variovolant3 && variovolant3.checked)) {

					document.querySelectorAll('button[data-variovolant]').forEach(el => {
						if(el.classList.contains('listenToVolant')) {
							el.classList.add('patternHide');
						}
					});

					if(variovolant1 && variovolant1.checked) {
						document.querySelectorAll('.variovolant0').forEach(el => {
							if(el.classList.contains('listenToVolant')) {
								el.classList.remove('patternHide');
							}
						});
					}
					if(variovolant2 && variovolant2.checked) {
						document.querySelectorAll('.variovolant900').forEach(el => {
							if(el.classList.contains('listenToVolant')) {
								el.classList.remove('patternHide');
							}
						});
					}
					if(variovolant3 && variovolant3.checked) {
						document.querySelectorAll('.variovolant1500').forEach(el => {
							if(el.classList.contains('listenToVolant')) {
								el.classList.remove('patternHide');
							}
						});
					}

				}
			}, 500)
		}
	}

	render() {

		const {item, value, volant, inputType} = this.props;
		const {imageExist} = this.state;

		// if(item.name.includes('Soltis Veozip Edelweiss')) {
		// 	console.log(item)
		// }

		const mapCategories = () => {
			let result = [];
			const categories = item.categories;
			for (let i in categories) {
				const value = categories[i].value;
				if(value !== '0') {
					result[`data-${i}`] = categories[i].value;
				}
			}
			result['data-variovolant'] = item.variovolant ? item.variovolant : false;
			return result;
		}

		return (
			<Fragment>
				{/*<Card className={`picker shadow pattern${value === item.name ? ' active' : ''}`}*/}
				{(volant && item.variovolant !== '0') || !volant ?
					<Card
						className={`picker shadow pattern pattern_${inputType} filteritem-${item.name}${volant ? ' listenToVolant ' : ''}${item.variovolant && item.variovolant.includes('900') ? ' variovolant900' : ''}${item.variovolant && item.variovolant.includes('1500') ? ' variovolant1500' : ''}${item.variovolant && item.variovolant.includes('default') ? ' variovolant0' : ''}`}
						tags={
							{0: item.fileUrl.label.toLowerCase()}
						}
						attributes={mapCategories()}
						top={
							<Fragment>
								{/*{imageExist &&*/}
								{/*  <Fragment>*/}
								{/*	  <img src={item.fileUrl.signedUrl} className="d-block card-img-top" style={{width: '100%', height: '6rem', objectFit: 'cover'}} onError={event => {*/}
								{/*		  event.target.src = ""*/}
								{/*		  event.target.classList.add('d-none');*/}
								{/*		  event.onerror = null*/}
								{/*	  }} />*/}
								{/*  </Fragment>*/}
								{/*}*/}
								<Fragment>
									<img
										src={item.fileUrl.signedUrl}
										className="d-block card-img-top"
										style={{
											width: '100%',
											height: '6rem',
											objectFit: 'cover'
										}}
										onError={event => {
											event.target.src = ""
											event.target.classList.add('d-none');
											event.onerror = null
										}}/>
								</Fragment>
							</Fragment>
						}
						handleAsButton={true}
						id={`${item.id}${volant ? '_V' : ''}`}
						onClick={() => {
							if (!volant) {
								this.handleClick(`${item.name.replaceAll('.jpg', '').replaceAll('.tif', '')}${!volant ? '_V' : ''}`)
							}
							this.handleClick(`${item.name.replaceAll('.jpg', '').replaceAll('.tif', '')}${volant ? '_VV900' : ''}`);
							this.handleClick(`${item.name.replaceAll('.jpg', '').replaceAll('.tif', '')}${volant ? '_VV1500' : ''}`);
						}}
					>
						{item.supplier}
						<small className="d-block">{item.fileUrl.label}</small>
						{/*<small className="d-block">{item.variovolant}</small>*/}
					</Card>
					:
					<Fragment>
					</Fragment>
				}
			</Fragment>
		)
	}
}
